import { useEffect, useState } from "react";
import CandidateApplicationForm from "./CandidateApplicationForm";
import CaseActions from "./CaseActions";
import HrPending from "./HrPending";
import { columns_report, dummyData_report } from "./case_data";
import { useLocation } from "react-router";
import dayjs from "dayjs";
import { all_routes } from "../../../router/all_routes";
import useApi from "../../../../core/customhook/useApi";
import { exportAntdTableToExcel } from "../../../../core/utils/exportExcel";
import { cellWidth } from "../../../../core/methods/tableCellWidth";
import webservice_url from "../../../../core/webservice/Webservice_url";
import { PageBreadcrumb } from "../../../../core/common/BreadCrumbForm";
import SimpleTabItems from "../../../../core/common/SimpleTabItems";
import Datatable from "../../../../core/common/dataTable";
import Footer from "../../../../core/common/Footer";
import SnipperLoader from "../../../../core/common/loader/SnipperLoader";
import { PageLoader } from "../../../../core/common/loader/PageLoader";
import Loader from "../../../../core/common/loader";
import Loading from "../../../../core/common/custom-loading/Loading";
import CaseTimelineModal from "../CaseTimelineModal";
import TimelineModal from "../../../../core/common/TimelineModal";
import { getSearchableHeader } from "../../../../core/utils/getSearchableHeader";
import { ColumnsType } from "antd/es/table";

interface TabProps {
  id: string;
  label: string;
  onClick?: () => void;
}

export interface CaseDetailData {
  assisted_verified_checks: number;
  candidate_submitted_checks: string;
  non_assisted_checks: number;
  non_assisted_verified_checks: number;
  assisted_checks: number;
  verified_assisted_checks: number;
  applicant_name: string;
  case_id: string;
  case_code: string;
  ordered_by: string;
  project_name: string;
  project_id: string;
  candidate_employee_id: string;
  department_name: string;
  department_id: string;
  case_type: string;
  case_receive_date: string;
  sla_start_date: string;
  due_date: string;
  completion_date: string | null;
  tat_days: string;
  joining_date: string;
  package_id: string;
  package_name: string;
  package_code: string;
  sop: string;
  last_updated: string;
  total_checks: string;
  stopped_checks: string;
  completed_checks: string;
  insuff_expire_checks: string;
  wip_checks: string;
  insufficiency_raised_checks: string;
  interimStatus: string;
  finalReportColourCode: string;
  interimReportDate: string;
  finalReportDate: string;
  current_status: string;
  case_stopped_at: string;
  reason: string;
  hrms_id: string;
}

const formatDate = (value?: string | null) =>
  value ? dayjs(value).format("DD-MM-YYYY") : "-";
const breadcrumbItem = [
  { label: "Live Case Progress" },
  { label: "Case Details" },
];

const CaseDetails = () => {
  const [caseDetail, setCaseDetails] = useState<CaseDetailData>();
  const [CheckHistory, setCheckHistory] = useState<any>([]);

  const location = useLocation();
  const { case_id, assignment_id } = location?.state ?? {};

  const [showApplicationModal, setShowApplicationModal] =
    useState<boolean>(false);
  const [showDownloadReportModal, setShowDownloadReportModal] =
    useState<boolean>(false);
  const [showCheckDetailsModal, setShowCheckDetailsModal] =
    useState<boolean>(false);
  const [inviteDate, setInviteDate] = useState("");
  const [caseStatus, SetCaseStatus] = useState("");

  const [showTimeline, setShowTimeline] = useState<boolean>(false);
  const [timelineData, setTimelineData] = useState<any[]>([]);
  const [timelineLoading, setTimelineLoading] = useState<boolean>(false);
  const [inventoryColumnSearch, setInventoryColumnSearch] = useState<
    Record<string, string>
  >({});
  type InviteItem = any;
  const filteredData = (Array.isArray(CheckHistory) ? CheckHistory : []).filter(
    (item: InviteItem) => {
      return Object.entries(inventoryColumnSearch).every(([key, value]) => {
        if (!value) return true;

        return String(item[key as keyof InviteItem] ?? "")
          .toLowerCase()
          .includes(value.toLowerCase());
      });
    },
  );

  // API
  const getCaseDetails = useApi<any>(webservice_url.caseDetailsAPI, {
    method: "POST",
    autoCall: false,
    handleGlobalError: false,
  });
  const getChecksHistoryAPI = useApi<any>(
    `/api/v1/candidate/forms/case-check-summary/${assignment_id}`,
    {
      method: "GET",
      autoCall: false,
      handleGlobalError: false,
    },
  );

  const getCaseLog = useApi<any>(
    `/api/v1/candidate/forms/timeline/${assignment_id}`,
    {
      method: "GET",
      autoCall: false,
      handleGlobalError: false,
    },
  );

  const handleViewLog = async (assignmentTemplateId?: string) => {
    if (!assignmentTemplateId) return;

    setShowTimeline(true);
    setTimelineLoading(true);

    try {
      const res = await getCaseLog.callApi(
        undefined,
        `/api/v1/candidate/forms/timeline/${assignmentTemplateId}`,
      );

      setTimelineData(res?.data ?? []);
    } catch (err) {
      console.error(err);
      setTimelineData([]);
    } finally {
      setTimelineLoading(false);
    }
  };

  // handleDownload Excel
  const handleDownloadExcel = () => {
    exportAntdTableToExcel({
      columns: columns_checksHistory,
      dataSource: CheckHistory,
      fileName: "Case_checks_report",
      sheetName: "Case Check Report",
    });
  };

  const fetchCheckHistory = async () => {
    try {
      const res = await getChecksHistoryAPI.callApi();
      const historyList = Array.isArray(res?.data?.checks)
        ? res?.data?.checks
        : Array.isArray(res?.data?.checks)
          ? res?.data?.checks
          : [];
      setInviteDate(res?.data?.candidate_invite_date);
      SetCaseStatus(res?.data?.case_status);
      setCheckHistory([
        ...historyList.filter((d: any) => d.check_type === "NON-ASSISTED"),
        ...historyList.filter((d: any) => d.check_type === "ASSISTED"),
        ...historyList.filter(
          (d: any) => !["NON-ASSISTED", "ASSISTED"].includes(d.check_type),
        ),
      ]);
    } catch (error) {
      console.log(error, "error");
      setCheckHistory([]);
    }
  };
  useEffect(() => {
    if (assignment_id) {
      fetchCheckHistory();
    }
  }, [assignment_id]);

  const tabs: TabProps[] = [
    { id: "caseTimeline", label: "Case Timeline" },
    {
      id: "candidateApplicationForm",
      label: "Candidate Application Form",
      onClick: () => setShowApplicationModal(true),
    },
    {
      id: "checkDetails",
      label: "Check Details",
      onClick: () => {
        setShowCheckDetailsModal(true);
        if (assignment_id) {
          fetchCheckHistory();
        }
      },
    },
  ];

  // const columns_checksHistory = [
  //   {
  //     title: "Sr. No.",
  //     key: "srNo",
  //     width: 80,
  //     align: "center",
  //     render: (_: any, __: any, index: number) => index + 1,
  //   },
  //   {
  //     title: "Checks",
  //     dataIndex: "check_name",
  //     key: "check_name",
  //     onCell: () => cellWidth(180),
  //   },
  //   {
  //     title: "Key Value",
  //     dataIndex: "key_value",
  //     key: "key_value",
  //     onCell: () => cellWidth(240),
  //   },
  //   {
  //     title: "Activity View",
  //     key: "viewLog",
  //     onCell: () => cellWidth(190),
  //     render: (_: any, record: any) => (
  //       <div
  //         className="text-center text-dark"
  //         style={{ cursor: "pointer" }}
  //         onClick={() => handleViewLog(record?.assignment_template_id)}
  //       >
  //         <i className="ti ti-eye"></i>
  //       </div>
  //     ),
  //   },
  //   {
  //     title: "Check Current Status",
  //     dataIndex: "status",
  //     key: "status",
  //     onCell: () => cellWidth(150),
  //   },
  //   {
  //     title: "Start Date",
  //     dataIndex: "start_date",
  //     key: "start_date",
  //     render: (value: string) =>
  //       value ? dayjs(value).format("DD-MM-YYYY") : "-",
  //     onCell: () => cellWidth(130),
  //   },
  //   {
  //     title: "Completed Date",
  //     dataIndex: "completed_date",
  //     render: (value: string) =>
  //       value ? dayjs(value).format("DD-MM-YYYY") : "-",
  //     key: "completed_date",
  //   },
  // ];

  const columns_checksHistory: ColumnsType<any> = [
    {
      title: "Sr. No.",
      key: "srNo",
      onCell: () => cellWidth(100),
      align: "center",
      render: (_: any, __: any, index: number) => index + 1,
    },
    {
      title: getSearchableHeader(
        "Checks",
        "check_name",
        setInventoryColumnSearch,
      ),
      dataIndex: "check_name",
      key: "check_name",
      onCell: () => cellWidth(180),
    },
    {
      title: getSearchableHeader(
        "Key Value",
        "key_value",
        setInventoryColumnSearch,
      ),
      dataIndex: "key_value",
      key: "key_value",
      onCell: () => cellWidth(240),
    },
    {
      title: "View Timeline",
      key: "viewLog",
      onCell: () => cellWidth(140),
      render: (_: any, record: any) => (
        <div
          className="text-center text-dark"
          style={{ cursor: "pointer" }}
          onClick={() => handleViewLog(record?.assignment_template_id)}
        >
          <i className="ti ti-eye"></i>
        </div>
      ),
    },
    {
      title: getSearchableHeader(
        "Check Current Status",
        "status",
        setInventoryColumnSearch,
      ),
      dataIndex: "status",
      key: "status",
      onCell: () => cellWidth(150),
    },
    {
      title: getSearchableHeader(
        "Start Date",
        "start_date",
        setInventoryColumnSearch,
      ),
      dataIndex: "start_date",
      key: "start_date",
      render: (value: string) =>
        value ? dayjs(value).format("DD-MM-YYYY") : "-",
      onCell: () => cellWidth(130),
    },
    {
      title: getSearchableHeader(
        "Completed Date",
        "completed_date",
        setInventoryColumnSearch,
      ),
      dataIndex: "completed_date",
      key: "completed_date",
      render: (value: string) =>
        value ? dayjs(value).format("DD-MM-YYYY") : "-",
      onCell: () => cellWidth(150),
    },
    {
      title: "Check Type",
      dataIndex: "check_type",
      key: "check_type",
      onCell: () => cellWidth(150),
    },
  ];
 
  const fetchCaseDetails = async () => {
    try {
      const res = await getCaseDetails.callApi({
        case_id: case_id,
      });
      setCaseDetails(res?.data);
    } catch (error) {
      console.log(error, "error");
    }
  };

  useEffect(() => {
    fetchCaseDetails();
  }, [case_id]);

  const handleClose = async () => {
    console.log("handle close");
  };

  const bottomTabs = [
    {
      id: "caseActions",
      label: "Case Actions",
      component: (
        <CaseActions
          caseDetail={caseDetail}
          assignmentId={assignment_id}
          onSuccess={fetchCaseDetails}
        />
      ),
    },
    // {
    //   id: "hrPendingActions",
    //   label: "HR Pending Actions",
    //   component: <HrPending />,
    // },
  ];

  const [activeTab, setActiveTab] = useState(tabs[0].id);
  const [activeBottomTab, setActiveBottomTab] = useState<string>(
    bottomTabs[0].id,
  );

  const ActiveBottomComponent = bottomTabs?.find(
    (i) => i.id == activeBottomTab,
  )?.component;
 
  return (
    <>
      <div className="page-wrapper">
        <div className="content px-2 px-md-4 pb-5">
          {getCaseDetails.loading ? (
            <PageLoader />
          ) : (
            <>
              <PageBreadcrumb
                title="Case Details"
                breadcrumbs={breadcrumbItem}
                showBackButton={true}
                backRoute={-1}
                // backRoute={all_routes.verifier_liveCaseProgress}
              />

              <div className=" border-secondary pb-2">
                <span className="small">Case Status:</span>
                <span className="badge bg-success ms-2 px-2 py-2 rounded-pill fw-semibold">
                  {caseDetail?.current_status || "-"}
                </span>
              </div>
              <div className="case-tab-card">
                <SimpleTabItems
                  tabList={tabs}
                  activeTab={activeTab}
                  handleClick={(d: any) => {
                    setActiveTab(d.id);
                    d?.onClick?.();
                  }}
                />
              </div>

              <div className="card border-0 shadow-sm mb-3 mt-3">
                {/* {getCaseDetails.loading ? (
                    <Loading />
                  ) : ( */}
                <div className="overflow-hidden">
                  <div className="card-header border-0 text-white py-3 px-4">
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <h5 className="mb-1 fw-bold text-dark">
                          <i className="ti ti-folder me-2"></i>
                          Case Details
                        </h5>
                        <small className="text-dark">
                          Complete information related to this case
                        </small>
                      </div>

                      <span
                        style={{ background: "antiquewhite" }}
                        className="badge text-primary px-3 py-2 fs-13 rounded-pill"
                      >
                        Case ID: {caseDetail?.case_id || "-"}
                      </span>
                    </div>
                  </div>
                  <div className="card-body p-4 pt-0">
                    <div className="row g-4">
                      <div className="col-lg-6">
                        <div className="border rounded-4 h-100 p-3 bg-light">
                          <h6 className="fw-bold mb-3 text-primary">
                            <i className="ti ti-user me-2"></i>
                            Applicant Information
                          </h6>

                          {[
                            ["Applicant Name", caseDetail?.applicant_name],
                            ["Case ID", caseDetail?.case_id],
                            // ["Ordered By", caseDetail?.ordered_by],
                            ["Ordered By", "Teleperformance SE"],
                            ["Client Name", caseDetail?.project_name],
                            ["Candidate Id", caseDetail?.hrms_id],
                            ["Department", caseDetail?.department_name],
                            ["Case Type", caseDetail?.case_type],
                          ].map(([label, value]) => (
                            <div
                              key={label}
                              className="d-flex justify-content-between align-items-start border-bottom py-2"
                            >
                              <span
                                className="text-secondary fw-semibold"
                                style={{ fontSize: 13 }}
                              >
                                {label}
                              </span>

                              <span
                                className="fw-bold text-dark text-end"
                                style={{
                                  maxWidth: "55%",
                                  wordBreak: "break-word",
                                }}
                              >
                                {value || "-"}
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>

                      {/* Timeline */}
                      <div className="col-lg-6">
                        <div className="border rounded-4 h-100 p-3 bg-light">
                          <h6 className="fw-bold mb-3 text-success">
                            <i className="ti ti-calendar-event me-2"></i>
                            Timeline
                          </h6>

                          {[
                            [
                              "Case Receive Date",
                              formatDate(caseDetail?.case_receive_date),
                            ],
                            [
                              "SLA Start Date",
                              formatDate(caseDetail?.sla_start_date),
                            ],
                            ["Due Date", formatDate(caseDetail?.due_date)],
                            [
                              "Completion Date",
                              formatDate(caseDetail?.completion_date),
                            ],
                            [
                              "Joining Date",
                              formatDate(caseDetail?.joining_date),
                            ],
                            ["TAT", caseDetail?.tat_days],
                          ]?.map(([label, value]) => (
                            <div
                              key={label}
                              className="d-flex justify-content-between align-items-start border-bottom py-2"
                            >
                              <span
                                className="text-secondary fw-semibold"
                                style={{ fontSize: 13 }}
                              >
                                {label}
                              </span>

                              <span
                                className="fw-bold text-dark text-end"
                                style={{
                                  maxWidth: "55%",
                                  wordBreak: "break-word",
                                }}
                              >
                                {/* {value || "-"} */}
                                {label === "TAT" ? (
                                  <>
                                    {value} {!!value && "days"}
                                  </>
                                ) : (
                                  value || "-"
                                )}
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>

                      {/* Status */}
                      {/* <div className="col-lg-4">
                        <div className="border rounded-4 h-100 p-3 bg-light">
                          <h6 className="fw-bold mb-3 text-danger">
                            <i className="ti ti-clipboard-check me-2"></i>
                            Status & Reports
                          </h6>

                          <div className="d-flex justify-content-between border-bottom py-2">
                            <span className="text-secondary fw-semibold">
                              Interim Status
                            </span>

                            <span className="badge bg-info px-3 py-2 rounded-pill">
                              {caseDetail?.current_status || "-"}
                            </span>
                          </div>

                          <div className="d-flex justify-content-between border-bottom py-2">
                            <span className="text-secondary fw-semibold">
                              Final Report
                            </span>

                            <span
                              className={`badge px-3 py-2 rounded-pill
              ${caseDetail?.finalReportColourCode === "GREEN"
                                  ? "bg-success"
                                  : caseDetail?.finalReportColourCode === "RED"
                                    ? "bg-danger"
                                    : caseDetail?.finalReportColourCode === "AMBER"
                                      ? "bg-warning text-dark"
                                      : "bg-secondary"
                                }`}
                            >
                              {caseDetail?.finalReportColourCode || "-"}
                            </span>
                          </div>

                          <div className="d-flex justify-content-between border-bottom py-3">
                            <span className="text-secondary fw-semibold">
                              Interim Report Date
                            </span>

                            <span className="fw-bold">
                              {formatDate(caseDetail?.interimReportDate) || "-"}
                            </span>
                          </div>

                          <div className="d-flex justify-content-between py-3">
                            <span className="text-secondary fw-semibold">
                              Final Report Date
                            </span>

                            <span className="fw-bold">
                              {formatDate(caseDetail?.finalReportDate) || "-"}
                            </span>
                          </div>
                        </div>
                      </div> */}
                    </div>
                  </div>

                  <div className="border-top bg-light-subtle p-4">
                    {/* Package Ordered */}
                    <div className="info-box mb-3">
                      <div className="info-label">
                        <i className="ti ti-package me-2 text-warning"></i>
                        Package Ordered
                      </div>
                      <div className="info-value">{caseDetail?.sop || "-"}</div>
                    </div>

                    {(() => {
                      const status = caseDetail?.current_status
                        ?.trim()
                        ?.toUpperCase();

                      if (status === "STOP") {
                        return (
                          <div className="mt-4">
                            <h6 className="fw-bold text-danger mb-3 d-flex align-items-center">
                              <i className="ti ti-alert-circle me-2"></i>
                              Case Stop Details
                            </h6>

                            <div className="info-box mb-3">
                              <div className="info-label">
                                <i className="ti ti-calendar-event me-2 text-danger"></i>
                                Stopped At
                              </div>
                              <div className="info-value">
                                {formatDate(caseDetail?.case_stopped_at)}
                              </div>
                            </div>

                            <div className="info-box mb-3">
                              <div className="info-label">
                                <i className="ti ti-user me-2 text-danger"></i>
                                Stopped By
                              </div>
                              <div className="info-value">
                                {caseDetail?.ordered_by ?? "-"}
                              </div>
                            </div>

                            <div className="info-box">
                              <div className="info-label">
                                <i className="ti ti-message-report me-2 text-danger"></i>
                                Reason
                              </div>
                              <div className="info-value">
                                {caseDetail?.reason ?? "-"}
                              </div>
                            </div>
                          </div>
                        );
                      }

                      if (status === "INSUFF_EXPIRED") {
                        return (
                          <div className="mt-4">
                            <h6 className="fw-bold text-warning mb-3 d-flex align-items-center">
                              <i className="ti ti-alert-triangle me-2"></i>
                              Insufficiency Details
                            </h6>

                            <div className="info-box mb-3">
                              <div className="info-label">
                                <i className="ti ti-calendar-event me-2 text-warning"></i>
                                Insuff Raised Date
                              </div>
                              <div className="info-value">
                                {/* {formatDate(caseDetail?.insuff_raised_at)} */}
                              </div>
                            </div>

                            <div className="info-box mb-3">
                              <div className="info-label">
                                <i className="ti ti-user me-2 text-warning"></i>
                                Insuff Raised By
                              </div>
                              <div className="info-value">
                                {caseDetail?.ordered_by ?? "-"}
                              </div>
                            </div>

                            <div className="info-box">
                              <div className="info-label">
                                <i className="ti ti-message-report me-2 text-warning"></i>
                                Reason
                              </div>
                              <div className="info-value">
                                {/* {caseDetail?.insuff_reason ?? "-"} */}
                              </div>
                            </div>
                          </div>
                        );
                      }

                      return null;
                    })()}
                  </div>
                </div>
                {/* )} */}
                {/* <div className="card border-0 shadow-sm mt-3 mx-3">
                  <div className="card-body p-0">
                    {caseDetail ? (
                      <div className="table-responsive">
                        <table className="table table-hover align-middle mb-0">
                          <thead>
                            <tr>
                              <th className="px-4 py-3">Last Updated</th>

                              <th className="text-center py-3">Total Checks</th>

                              <th className="text-center py-3">Stopped</th>

                              <th className="text-center py-3">Completed</th>

                              <th className="text-center py-3">
                                Insuff Expire
                              </th>

                              <th className="text-center py-3">WIP</th>

                              <th className="text-center py-3">HR Pendency</th>
                            </tr>
                          </thead>

                          <tbody>
                            <tr>
                              <td className="px-4">
                                <div className="d-flex align-items-center">
                                  <i className="ti ti-calendar-event text-muted me-2"></i>

                                  <span className="fw-medium">
                                    {formatDate(caseDetail?.last_updated)}
                                  </span>
                                </div>
                              </td>

                              <td className="text-center">
                                <span
                                  className="badge rounded-pill px-3 py-2"
                                  style={{
                                    backgroundColor: "#eef0ff",
                                    color: "#34359B",
                                    fontSize: "13px",
                                  }}
                                >
                                  {caseDetail?.total_checks ?? 0}
                                </span>
                              </td>

                              <td className="text-center">
                                <span
                                  className="badge rounded-pill px-3 py-2"
                                  style={{
                                    backgroundColor: "#fff0f0",
                                    color: "#dc3545",
                                    fontSize: "13px",
                                  }}
                                >
                                  {caseDetail?.stopped_checks ?? 0}
                                </span>
                              </td>

                              <td className="text-center">
                                <span
                                  className="badge rounded-pill px-3 py-2"
                                  style={{
                                    backgroundColor: "#eaf8ef",
                                    color: "#198754",
                                    fontSize: "13px",
                                  }}
                                >
                                  {caseDetail?.completed_checks ?? 0}
                                </span>
                              </td>

                              <td className="text-center">
                                <span
                                  className="badge rounded-pill px-3 py-2"
                                  style={{
                                    backgroundColor: "#fff7e6",
                                    color: "#f59e0b",
                                    fontSize: "13px",
                                  }}
                                >
                                  {caseDetail?.insuff_expire_checks ?? 0}
                                </span>
                              </td>

                              <td className="text-center">
                                <span
                                  className="badge rounded-pill px-3 py-2"
                                  style={{
                                    backgroundColor: "#eaf4ff",
                                    color: "#0d6efd",
                                    fontSize: "13px",
                                  }}
                                >
                                  {caseDetail?.wip_checks ?? 0}
                                </span>
                              </td>

                              <td className="text-center">
                                <span
                                  className="badge rounded-pill px-3 py-2"
                                  style={{
                                    backgroundColor: "#f3eefe",
                                    color: "#6f42c1",
                                    fontSize: "13px",
                                  }}
                                >
                                  {caseDetail?.insufficiency_raised_checks ?? 0}
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <div className="text-center py-5">
                        <i
                          className="ti ti-database-off text-muted"
                          style={{ fontSize: "40px" }}
                        ></i>

                        <p className="text-muted mt-2 mb-0">
                          No case details available
                        </p>
                      </div>
                    )}
                  </div>
                </div> */}
                <div className="card border-0 mt-3">
                  <div className="card-body p-0">
                    {caseDetail ? (
                      <div className="table-responsive">
                        <table className="table table-hover align-middle mb-0 text-nowrap">
                          <thead>
                            <tr>
                              <th className="px-4 py-3">Last Updated</th>
                              <th className="text-center py-3">Total Checks</th>
                              <th className="text-center py-3">Assisted</th>
                              <th className="text-center py-3">Non-Assisted</th>
                              <th className="text-center py-3">
                                Candidate Submited
                              </th>
                              <th className="text-center py-3">Stopped</th>
                              <th className="text-center py-3">Completed</th>
                              <th className="text-center py-3">WIP</th>

                              <th className="text-center py-3">HR Pendency</th>
                            </tr>
                          </thead>

                          <tbody>
                            <tr>
                              <td className="px-4">
                                <div className="d-flex align-items-center">
                                  <i className="ti ti-calendar-event text-muted me-2"></i>

                                  <span className="fw-medium">
                                    {formatDate(caseDetail.last_updated)}
                                  </span>
                                </div>
                              </td>

                              <td className="text-center">
                                <span
                                  className="badge rounded-pill px-3 py-2"
                                  style={{
                                    backgroundColor: "#eef0ff",
                                    color: "#34359B",
                                    fontSize: "13px",
                                  }}
                                >
                                  {caseDetail.total_checks ?? 0}
                                </span>
                              </td>
                              <td className="px-4">
                                <div className="d-flex flex-column align-items-center">
                                  <span className="fw-medium">
                                    {Number(
                                      caseDetail.assisted_verified_checks ?? 0,
                                    )}{" "}
                                    / {Number(caseDetail.assisted_checks ?? 0)}
                                  </span>

                                  <div
                                    className={`mt-1 ${
                                      Number(
                                        caseDetail.assisted_verified_checks ??
                                          0,
                                      ) ===
                                      Number(caseDetail.assisted_checks ?? 0)
                                        ? "text-success"
                                        : "text-warning"
                                    }`}
                                  >
                                    {Number(
                                      caseDetail.assisted_verified_checks ?? 0,
                                    ) ===
                                    Number(caseDetail.assisted_checks ?? 0)
                                      ? "Complete"
                                      : "In Progress"}
                                  </div>
                                </div>
                              </td>

                              <td className="px-4">
                                <div className="d-flex flex-column align-items-center">
                                  <span className="fw-medium">
                                    {Number(
                                      caseDetail.non_assisted_verified_checks ??
                                        0,
                                    )}{" "}
                                    /{" "}
                                    {Number(
                                      caseDetail.non_assisted_checks ?? 0,
                                    )}
                                  </span>

                                  <div
                                    className={`mt-1 ${
                                      Number(
                                        caseDetail.non_assisted_verified_checks ??
                                          0,
                                      ) ===
                                      Number(
                                        caseDetail.non_assisted_checks ?? 0,
                                      )
                                        ? "text-success"
                                        : "text-warning"
                                    }`}
                                  >
                                    {Number(
                                      caseDetail.non_assisted_verified_checks ??
                                        0,
                                    ) ===
                                    Number(caseDetail.non_assisted_checks ?? 0)
                                      ? "Complete"
                                      : "In Progress"}
                                  </div>
                                </div>
                              </td>
                              <td className="px-4">
                                <div className="d-flex justify-content-center align-items-center">
                                  <span
                                    className="badge rounded-pill px-3 py-2"
                                    style={{
                                      backgroundColor: "#eaf8ef",
                                      color: "#198754",
                                      fontSize: "13px",
                                    }}
                                  >
                                    {caseDetail.candidate_submitted_checks ??
                                      ""}
                                  </span>
                                </div>
                              </td>

                              <td className="text-center">
                                <span
                                  className="badge rounded-pill px-3 py-2"
                                  style={{
                                    backgroundColor: "#fff0f0",
                                    color: "#dc3545",
                                    fontSize: "13px",
                                  }}
                                >
                                  {caseDetail.stopped_checks ?? 0}
                                </span>
                              </td>

                              <td className="text-center">
                                <span
                                  className="badge rounded-pill px-3 py-2"
                                  style={{
                                    backgroundColor: "#eaf8ef",
                                    color: "#198754",
                                    fontSize: "13px",
                                  }}
                                >
                                  {caseDetail.completed_checks ?? 0}
                                </span>
                              </td>
                              <td className="text-center">
                                <span
                                  className="badge rounded-pill px-3 py-2"
                                  style={{
                                    backgroundColor: "#eaf4ff",
                                    color: "#0d6efd",
                                    fontSize: "13px",
                                  }}
                                >
                                  {caseDetail.wip_checks ?? 0}
                                </span>
                              </td>

                              <td className="text-center">
                                <span
                                  className="badge rounded-pill px-3 py-2"
                                  style={{
                                    backgroundColor: "#f3eefe",
                                    color: "#6f42c1",
                                    fontSize: "13px",
                                  }}
                                >
                                  {caseDetail.insufficiency_raised_checks ?? 0}
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <div className="text-center py-5">
                        <i
                          className="ti ti-database-off text-muted"
                          style={{ fontSize: "40px" }}
                        ></i>

                        <p className="text-muted mt-2 mb-0">
                          No case details available
                        </p>
                      </div>
                    )}
                  </div>
                </div>
                {/* </div> */}
              </div>

              {/* Bottom Tabs */}
              <div className="case-tab-card">
                {/* <TabItems
              tabList={bottomTabs}
              activeTab={activeBottomTab}
              handleClick={(d) => {
                setActiveBottomTab(d.id);
              }}
            /> */}
                {/* <SimpleTabItems
                  tabList={bottomTabs}
                  activeTab={activeBottomTab}
                  handleClick={(d: any) => {
                    setActiveBottomTab(d.id);
                    d?.onClick?.();
                  }}
                /> */}
              </div>
              <div>{ActiveBottomComponent}</div>
            </>
          )}
        </div>

        {/* ---- Footer ---- */}
        <Footer />
      </div>

      {/* candidate application form */}
      <CandidateApplicationForm
        assignmentId={assignment_id}
        isOpen={showApplicationModal}
        handleClose={() => setShowApplicationModal(false)}
      />

      {/* backgroundCheckReport - Download Report Modal */}
      {showDownloadReportModal && (
        <>
          <div
            className="modal-backdrop fade show"
            onClick={() => setShowDownloadReportModal(false)}
          />
          <div
            className="modal fade show"
            style={{ display: "block" }}
            role="dialog"
            aria-modal="true"
          >
            <div className="modal-dialog modal-dialog-centered modal-xl">
              <div
                className="modal-content mx-auto overflow-hidden"
                style={{ maxHeight: 600, maxWidth: 950 }}
              >
                <div className="modal-header">
                  <h3 className="fw-bold ">Report</h3>
                  <button
                    type="button"
                    className="btn-close custom-btn-close"
                    onClick={() => setShowDownloadReportModal(false)}
                    aria-label="Close"
                  >
                    <i className="ti ti-x" />
                  </button>
                </div>
                <div className="modal-body px-2 px-md-4 pb-3 pt-0 pt-md-3 overflow-y-auto">
                  <Datatable
                    dataSource={dummyData_report}
                    columns={columns_report}
                    Selection={false}
                    rowKey="case_id"
                  />
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {/* check details */}
      {/* {showCheckDetailsModal && (
        <>
          <div
            className="modal-backdrop fade show"
            onClick={() => setShowCheckDetailsModal(false)}
          />
          <div
            className="modal fade show"
            style={{ display: "block" }}
            role="dialog"
            aria-modal="true"
          >
            <div className="modal-dialog modal-dialog-centered modal-xl">
              <div
                className="modal-content mx-auto overflow-hidden"
                style={{ maxHeight: 550, maxWidth: 950 }}
              >
                <div className="modal-header">
                  <h3 className="fw-bold ">Checks History</h3>

                  <button
                    type="button"
                    className="btn-close custom-btn-close"
                    onClick={() => setShowCheckDetailsModal(false)}
                    aria-label="Close"
                  >
                    <i className="ti ti-x" />
                  </button>
                </div>
                <div className="modal-body px-2 px-md-4 pb-3 pt-0 pt-md-3 overflow-y-auto">
                  <p className="text-center text-muted">
                    Candidate Invite Date: 24-05-2026 | Current Employement:
                    Report in Progress (TL)
                  </p>

                  <Datatable
                    dataSource={CheckHistory}
                    columns={columns_checksHistory}
                    Selection={false}
                    isBordered={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </>
      )} */}
      {showCheckDetailsModal && (
        <>
          <div
            className="modal-backdrop fade show"
            onClick={() => setShowCheckDetailsModal(false)}
          />
          <div
            className="modal fade show"
            style={{ display: "block" }}
            role="dialog"
            aria-modal="true"
          >
            <div className="modal-dialog modal-dialog-centered modal-xl">
              <div className="modal-content caf-modal-content mx-auto overflow-hidden">
                <div className="modal-header border-0 d-flex flex-column align-items-stretch pb-0 caf-modal-header">
                  <div className="caf-modal-header-top">
                    <div className="caf-modal-title-group">
                      <div className="caf-modal-title-icon">
                        <i className="ti ti-history" />
                      </div>
                      <div className="caf-modal-title-text">
                        <h5>Checks History</h5>
                        <span>
                          Timeline of all background verification checks
                        </span>
                      </div>
                    </div>
                    <button
                      type="button"
                      className="caf-btn-close"
                      onClick={() => setShowCheckDetailsModal(false)}
                      aria-label="Close"
                    >
                      <i className="ti ti-x" />
                    </button>
                  </div>

                  <div className="caf-checkhistory-meta">
                    <span className="caf-meta-chip">
                      <i className="ti ti-calendar-event" />
                      Invited: {dayjs(inviteDate).format("DD-MM-YYYY")}
                    </span>
                    <span className="caf-meta-chip caf-meta-chip-accent">
                      <i className="ti ti-clock" />
                      Case Status : {caseStatus}
                    </span>
                  </div>
                </div>

                <div className="modal-body caf-modal-body px-2 px-md-4 pb-3 pt-0 pt-md-3 overflow-y-auto">
                  <div className="caf-section-card">
                    <div className="caf-section-header">
                      <div className="caf-section-header-left">
                        <div className="caf-section-icon">
                          <i className="ti ti-table" />
                        </div>
                        <div className="caf-section-titles">
                          <p className="caf-section-title">All Checks</p>
                          <p className="caf-section-subtitle">
                            Status of every check run for this candidate
                          </p>
                        </div>
                      </div>
                      <span className="caf-status-badge">
                        <span className="dot" />
                        {CheckHistory?.length || 0} Record
                        {CheckHistory?.length === 1 ? "" : "s"}
                      </span>
                    </div>

                    {getChecksHistoryAPI.loading ? (
                      <Loading />
                    ) : !CheckHistory || CheckHistory.length === 0 ? (
                      <div className="caf-empty-state">
                        No Check History Available
                      </div>
                    ) : (
                      <div className="caf-table-wrap mt-3 pt-2 pe-2">
                        <div className="text-end">
                          <button
                            className="btn btn-sm btn-primary"
                            onClick={handleDownloadExcel}
                            // disabled={loading}
                          >
                            <i className="ti ti-download pe-2"></i>
                            Export to Excel
                          </button>
                        </div>
                        <Datatable
                          dataSource={filteredData}
                          columns={columns_checksHistory}
                          Selection={false}
                          fixedHeader
                          tableHeight={650}
                          isBordered={true}
                        />
                      </div>
                    )}
                  </div>
                </div>

                <div className="caf-footer-actions">
                  <button
                    type="button"
                    onClick={() => setShowCheckDetailsModal(false)}
                    className="caf-btn caf-btn-secondary"
                  >
                    <i className="ti ti-x" />
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {showTimeline && (
        // <TimelineModal
        <CaseTimelineModal
          timelineData={timelineData}
          loading={timelineLoading}
          onClose={() => {
            setShowTimeline(false);
            setTimelineData([]);
          }}
        />
      )}
    </>
  );
};

export default CaseDetails;
